import { render, staticRenderFns } from "./PoliJump.vue?vue&type=template&id=b4b2fa00&scoped=true&"
import script from "./PoliJump.vue?vue&type=script&lang=js&"
export * from "./PoliJump.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b2fa00",
  null
  
)

export default component.exports